import { createWithEqualityFn } from 'zustand/traditional';

const _useTempState = createWithEqualityFn(() => ({
  preconsumedPower: 0, // 预计消耗算力
  showPowerFlag: true, // 算力消耗模式
  userVipInfo: null,
  proPurchaseModalVisible: false, // shakker页面的弹窗是否展示
  currentErrorCode: 0, // 当前服务器返回的错误码
  currentErrorMsg: 0, // 当前服务器返回的错误文案
  vipAccelerate: false, //会员加速状态
}));

export const useVipState = (field) => {
  if (field === false) {
    return _useTempState.getState(); // 可能是非响应式的
  }

  return _useTempState(field ? (state) => state[field] : undefined); // 响应式的
};

/**
 * 获取内部的状态，非响应式的
 * @param {*} fieldName
 * @returns
 */
export const getVipState = (fieldName) => (fieldName ? _useTempState.getState()[fieldName] : _useTempState.getState());

export const updateVipState = (partialState) => {
  _useTempState.setState(partialState);
};

/**
 * 加速状态转换对象
 */
export const switchHandlers = {
  open() {
    updateVipState({
      vipAccelerate: true,
    });
  },
  close() {
    updateVipState({
      vipAccelerate: false,
    });
  },
};
